/**
 * `IMonitoringSystem.parser` is declared as always present, and it is not: a document written straight into Mongo,
 * as the prod-to-nonprod replication does, has no `parser` field at all. Only systems created through NOCD get the
 * defaults. Reading `parser.sev1_def` off one of those threw during render and, because the editor is mounted by
 * the Alerts screen too and the record is persisted by redux-persist, it blanked the whole dashboard until
 * localStorage was cleared (nonprod, 2026-09-10).
 *
 * Rather than guard each read, the shape is repaired at the two doors a system comes through: the API response and
 * the rehydration from localStorage. Everything downstream can then trust the type.
 */
import { Parser } from '@serverfarm/nocd-commons';

/** Every keyword box present and empty, no regex: what "no parsing definitions" means to MEP. */
export const emptyParser = (): Parser => ({
  sev1_def: '',
  sev2_def: '',
  sev3_def: '',
  sev4_def: '',
  sev5_def: '',
  normal_def: '',
  offnormal_def: '',
  ignore_def: '',
  regex: [],
  timezone: '',
});

/**
 * Fills in whatever the document does not carry, and never overwrites a value that is there. A box left as `null`
 * by an older write counts as absent: the inputs are controlled and React warns when `value` turns null.
 */
export const withParserDefaults = (parser?: Parser | null): Parser => {
  const given = (parser || {}) as Partial<Parser>;
  const merged = emptyParser();
  (Object.keys(merged) as (keyof Parser)[]).forEach((box) => {
    if (given[box] !== undefined && given[box] !== null) {
      (merged as any)[box] = given[box];
    }
  });
  return merged;
};
